type SortOrder = {
	uuid: string;
	label: string;
	value: string;
};

export const sortOrders: SortOrder[] = [
	{
		uuid: "a03ec83d-01ca-4d2c-84ed-6033d2097a67",
		label: "Latest",
		value: "LATEST",
	},
	{
		uuid: "a03ec83d-01d3-4b90-9db5-f759c7e56cbe",
		label: "Positive",
		value: "POSITIVE",
	},
	{
		uuid: "a03ec83d-01d6-47a4-8952-212315f4f515",
		label: "Negative",
		value: "NEGATIVE",
	},
];
